import React from "react";
import classes from "./General.module.css";
import DefaultInput from "../../components/form/DefaultInput";
import { Divider } from "antd";
import ButtonArrangments from "../../components/form/ButtonArrangments";
import { currentUserLookup } from "../../lib/cachedLookups";
import useLookup from "../../hooks/useLookup";
import useLang from "../../hooks/useLang";

const General = () => {
	const { strings } = useLang("generalPage");
	const { data: currentUser } = useLookup(currentUserLookup);
	const currencySymbol = currentUser?.currencySymbol ?? "";
	const currencyDescription = currentUser?.currencyDescription ?? "";

	return (
		<div className={classes.mainContainer}>
			<h1 className={classes.title}>{strings?.title}</h1>
			<div className={classes.firstContainer}>
				<div className={classes.inputContainer}>
					<DefaultInput
						label={strings?.currencySymbolLabel}
						className={classes.input}
						placeholder={strings?.currencySymbolPlaceholder}
						value={currencySymbol}
					/>
					<DefaultInput
						label={strings?.currencyDescriptionLabel}
						className={classes.input}
						placeholder={strings?.currencyDescriptionPlaceholder}
						value={currencyDescription}
					/>
					<DefaultInput
						label={strings?.conversionLabel}
						className={classes.input}
						placeholder={strings?.conversionPlaceholder}
					/>
					<DefaultInput
						label={strings?.retrievalPeriodLabel}
						className={classes.input}
						placeholder={strings?.retrievalPeriodPlaceholder}
					/>
					<DefaultInput
						label={strings?.valueChangeAllowedLabel}
						className={classes.input}
						placeholder={strings?.valueChangeAllowedPlaceholder}
					/>
				</div>
			</div>
			<Divider />
			<ButtonArrangments text={strings?.saveButtonText} />
		</div>
	);
};

export default General;
